import { ArmorClass } from '@/classes/character/armorEnums';
import ArmorPiece from '@/classes/character/armorPiece';
import { Modifier } from '@/classes/character/modifier';

export default class Fighting {
  private armorPieces: ArmorPiece[] = [];

  public getTotalInitiativeBlock(): number {
    let block: number = 0;
    this.armorPieces.forEach((piece) => {
      block += piece.initiativeBlock;
    });
    return block;
  }

  public getTotalSlotBlock(): number {
    let block: number = 0;
    this.armorPieces.forEach((piece) => {
      block += piece.slotBlock;
    });
    return block;
  }

  public addArmorPiece(armorPiece: ArmorPiece) {
    this.armorPieces.push(armorPiece);
  }

  public getArmorClass(): ArmorClass {
    const numUnarmored = this.getNumberOfArmorPiecesByArmorClass(
      ArmorClass.ArmorLess,
    );
    const numLight = this.getNumberOfArmorPiecesByArmorClass(ArmorClass.Light);
    const numMedium = this.getNumberOfArmorPiecesByArmorClass(
      ArmorClass.Medium,
    );
    const numHeavy = this.getNumberOfArmorPiecesByArmorClass(ArmorClass.Heavy);
    const heighestNum = Math.max(numUnarmored, numLight, numMedium, numHeavy);

    switch (heighestNum) {
      case numHeavy:
        return ArmorClass.Heavy;
      case numMedium:
        return ArmorClass.Medium;
      case numLight:
        return ArmorClass.Light;
      default:
        return ArmorClass.ArmorLess;
    }
  }

  public getArmorModifiers(): Modifier[] {
    const overallQ = this.getOverallQuality();
    const armorClass = this.getArmorClass();

    switch (armorClass) {
      case ArmorClass.ArmorLess:
        return [];
      case ArmorClass.Light:
        return this.getModifiersLight(overallQ);
      case ArmorClass.Medium:
        return this.getModifiersMedium(overallQ);
      case ArmorClass.Heavy:
        return this.getModifiersHeavy(overallQ);
      default:
        throw new Error('Unknown armorclass for modifiers: ' + armorClass);
    }
  }

  private getNumberOfArmorPiecesByArmorClass(armorClass: ArmorClass) {
    let counter = 0;
    this.armorPieces.forEach((piece) => {
      if (piece.armorClass === armorClass) {
        counter++;
      }
    });
    return counter;
  }

  private getOverallQuality(): number {
    if (this.armorPieces.length === 0) {
      return 0;
    }

    let qualitySum = 0;
    this.armorPieces.forEach((piece) => {
      qualitySum += piece.quality;
    });
    return Math.round(qualitySum / this.armorPieces.length);
  }

  private getModifiersHeavy(quality: number): Modifier[] {
    const heavyMods: Modifier[] = [];
    const modSource: string = 'Armor_Heavy';
    heavyMods.push(new Modifier('lep', Math.round(quality * 3), modSource));
    heavyMods.push(new Modifier('ws', Math.round(quality / 2), modSource));
    heavyMods.push(new Modifier('slot', Math.round(quality / 6), modSource));

    return heavyMods;
  }

  private getModifiersMedium(quality: number): Modifier[] {
    const heavyMods: Modifier[] = [];
    const modSource: string = 'Armor_Medium';
    heavyMods.push(new Modifier('lep', Math.round(quality), modSource));
    heavyMods.push(new Modifier('ini', Math.round(quality * 2), modSource));
    heavyMods.push(new Modifier('slot', Math.round(quality / 5), modSource));

    return heavyMods;
  }

  private getModifiersLight(quality: number): Modifier[] {
    const heavyMods: Modifier[] = [];
    const modSource: string = 'Armor_Medium';
    heavyMods.push(new Modifier('ar', Math.round(quality), modSource));
    heavyMods.push(new Modifier('ini', Math.round(quality * 5), modSource));
    heavyMods.push(new Modifier('slot', Math.round(quality / 3), modSource));
    heavyMods.push(new Modifier('myw ', Math.round(quality), modSource));

    return heavyMods;
  }
}
